export default "__VITE_ASSET__DOoDa0BF__"